// // // src/Components/Visitors/ResidentPassGenerator.jsx
// // import React, { useState } from "react";
// // import { Alert, Button, Col, Form, Row } from "react-bootstrap";
// // import { useVisitorActions } from "../../hooks/useVisitorRequests";
// // import { useUploadSelfie } from "../../hooks/useVisitorUploadSelfie";
// // import { makeToken } from "../../hooks/useQR";
// // import { serverTimestamp, Timestamp } from "firebase/firestore";
// // // import QRCode from "qrcode.react";
// // import QRCode from "react-qr-code";

// // export default function ResidentPassGenerator({ community, currentUser }) {
// //   const { createRequest, updateRequest } = useVisitorActions();
// //   const { uploadSelfie, uploading } = useUploadSelfie();

// //   const [form, setForm] = useState({
// //     flatLabel: "", // Residents usually have fixed flat; you can auto-fill from profile
// //     visitorType: "delivery",
// //     visitorName: "",
// //     phone: "",
// //     purpose: "",
// //     selfieFile: null,
// //     validityMins: 120,
// //   });

// //   const [qrToken, setQrToken] = useState("");
// //   const [shareUrl, setShareUrl] = useState("");
// //   const [creating, setCreating] = useState(false);
// //   const [err, setErr] = useState("");

// //   const onCreatePass = async () => {
// //     setErr("");
// //     if (!form.flatLabel || !form.visitorName) {
// //       setErr("Flat and Visitor Name are required");
// //       return;
// //     }
// //     try {
// //       setCreating(true);
// //       const token = makeToken("VT");
// //       const expires = Timestamp.fromDate(
// //         new Date(Date.now() + form.validityMins * 60 * 1000)
// //       );

// //       const id = await createRequest({
// //         communityId: community.id,
// //         flatLabel: form.flatLabel.trim(),
// //         residentUid: currentUser?.uid || "", // IMPORTANT: set the owner
// //         visitorType: form.visitorType,
// //         visitorName: form.visitorName.trim(),
// //         phone: form.phone.trim(),
// //         purpose: form.purpose.trim(),
// //         createdBy: {
// //           uid: currentUser?.uid || null,
// //           role: "resident",
// //           method: "resident-pass",
// //         },
// //         qrToken: token,
// //         qrExpiresAt: expires,
// //         status: "preapproved",
// //         createdAt: serverTimestamp(),
// //       });

// //       let selfieUrl = null;
// //       if (form.selfieFile) {
// //         selfieUrl = await uploadSelfie(form.selfieFile, id);
// //         if (selfieUrl) await updateRequest(id, { selfieUrl });
// //       }

// //       const url = `${window.location.origin}/visit/${token}`;
// //       setQrToken(token);
// //       setShareUrl(url);
// //     } catch (e) {
// //       setErr(e?.message || "Failed to create pass");
// //     } finally {
// //       setCreating(false);
// //     }
// //   };

// //   return (
// //     <>
// //       <h5 className="mb-3">Resident Pre‑Approval Pass</h5>
// //       {err && <Alert variant="danger">{err}</Alert>}

// //       <Row className="g-2">
// //         <Col md={3}>
// //           <Form.Label>Flat</Form.Label>
// //           <Form.Control
// //             placeholder="Your flat (e.g., A-302)"
// //             value={form.flatLabel}
// //             onChange={(e) =>
// //               setForm((s) => ({ ...s, flatLabel: e.target.value }))
// //             }
// //           />
// //         </Col>
// //         <Col md={3}>
// //           <Form.Label>Type</Form.Label>
// //           <Form.Select
// //             value={form.visitorType}
// //             onChange={(e) =>
// //               setForm((s) => ({ ...s, visitorType: e.target.value }))
// //             }
// //           >
// //             <option value="delivery">Delivery</option>
// //             <option value="guest">Guest</option>
// //             <option value="service">Service</option>
// //             <option value="cab">Cab</option>
// //             <option value="other">Other</option>
// //           </Form.Select>
// //         </Col>
// //         <Col md={3}>
// //           <Form.Label>Visitor Name</Form.Label>
// //           <Form.Control
// //             value={form.visitorName}
// //             onChange={(e) =>
// //               setForm((s) => ({ ...s, visitorName: e.target.value }))
// //             }
// //           />
// //         </Col>
// //         <Col md={3}>
// //           <Form.Label>Phone</Form.Label>
// //           <Form.Control
// //             value={form.phone}
// //             onChange={(e) => setForm((s) => ({ ...s, phone: e.target.value }))}
// //           />
// //         </Col>
// //         <Col md={9}>
// //           <Form.Label>Purpose</Form.Label>
// //           <Form.Control
// //             value={form.purpose}
// //             onChange={(e) =>
// //               setForm((s) => ({ ...s, purpose: e.target.value }))
// //             }
// //           />
// //         </Col>
// //         <Col md={3}>
// //           <Form.Label>Validity (minutes)</Form.Label>
// //           <Form.Control
// //             type="number"
// //             min={15}
// //             max={1440}
// //             value={form.validityMins}
// //             onChange={(e) =>
// //               setForm((s) => ({ ...s, validityMins: Number(e.target.value) }))
// //             }
// //           />
// //         </Col>
// //         <Col md={3}>
// //           <Form.Label>Selfie (optional)</Form.Label>
// //           <Form.Control
// //             type="file"
// //             accept="image/*"
// //             onChange={(e) =>
// //               setForm((s) => ({
// //                 ...s,
// //                 selfieFile: e.target.files?.[0] || null,
// //               }))
// //             }
// //           />
// //         </Col>
// //         <Col xs="auto" className="mt-2">
// //           <Button disabled={creating || uploading} onClick={onCreatePass}>
// //             {creating ? "Generating…" : "Generate QR Pass"}
// //           </Button>
// //         </Col>
// //       </Row>

// //       {qrToken && (
// //         <div className="mt-4 d-flex flex-column align-items-center">
// //           <QRCode value={shareUrl} size={100} />
// //           <div className="text-muted mt-2 small">
// //             Share this QR / link with the visitor
// //           </div>
// //           <div className="mt-1">
// //             <a href={shareUrl} target="_blank" rel="noreferrer">
// //               {shareUrl}
// //             </a>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // }

// // src/Components/Visitors/ResidentPassGenerator.jsx
// import React, { useEffect, useState } from "react";
// import { Alert, Button, Col, Form, Row } from "react-bootstrap";
// import { useVisitorActions } from "../../hooks/useVisitorRequests";
// import { makeToken } from "../../hooks/useQR";
// import {
//   serverTimestamp,
//   Timestamp,
//   collection,
//   query,
//   where,
//   getDocs,
// } from "firebase/firestore";
// import QRCode from "react-qr-code";
// import { db } from "../../firebase";

// export default function ResidentPassGenerator({ community, currentUser }) {
//   const { createRequest } = useVisitorActions();

//   const [flatLabel, setFlatLabel] = useState(""); // auto-filled
//   const [form, setForm] = useState({
//     visitorType: "delivery",
//     visitorName: "",
//     phone: "",
//     purpose: "",
//     validityMins: 120,
//   });

//   const [qrToken, setQrToken] = useState("");
//   const [shareUrl, setShareUrl] = useState("");
//   const [creating, setCreating] = useState(false);
//   const [err, setErr] = useState("");

//   // 1) Auto-pick flat from units if not present in user profile
//   useEffect(() => {
//     let stop = false;
//     const loadUnit = async () => {
//       if (!community?.id || !currentUser?.uid) return;
//       // If your user doc already has a flatLabel, prefer that:
//       // const profileFlat = currentUser?.flatLabel; if (profileFlat) { setFlatLabel(profileFlat); return; }

//       const q = query(
//         collection(db, "communities", community.id, "units"),
//         where("occupiedByUid", "==", currentUser.uid)
//       );
//       const snap = await getDocs(q);
//       if (!stop && !snap.empty) {
//         const doc = snap.docs[0].data();
//         setFlatLabel(doc?.flatLabel || "");
//       }
//     };
//     loadUnit();
//     return () => {
//       stop = true;
//     };
//   }, [community?.id, currentUser?.uid]);

//   const onCreatePass = async () => {
//     setErr("");
//     if (!currentUser?.uid) {
//       setErr("Please sign in as resident to create a pass.");
//       return;
//     }
//     if (!flatLabel || !form.visitorName) {
//       setErr("Flat and Visitor Name are required");
//       return;
//     }
//     try {
//       setCreating(true);
//       const token = makeToken("VT");
//       const expires = Timestamp.fromDate(
//         new Date(Date.now() + form.validityMins * 60 * 1000)
//       );

//       await createRequest({
//         communityId: community.id,
//         flatLabel,
//         residentUid: currentUser.uid,
//         visitorType: form.visitorType,
//         visitorName: form.visitorName.trim(),
//         phone: form.phone.trim(),
//         purpose: form.purpose.trim(),
//         createdBy: {
//           uid: currentUser.uid,
//           role: "resident",
//           method: "resident-pass",
//         },
//         qrToken: token,
//         qrExpiresAt: expires,
//         status: "preapproved",
//         createdAt: serverTimestamp(),
//       });

//       const url = `${window.location.origin}/visit/${token}`;
//       setQrToken(token);
//       setShareUrl(url);
//     } catch (e) {
//       setErr(e?.message || "Failed to create pass");
//     } finally {
//       setCreating(false);
//     }
//   };

//   return (
//     <>
//       <h5 className="mb-3">Resident Pre‑Approval Pass</h5>
//       {err && <Alert variant="danger">{err}</Alert>}

//       <Row className="g-2">
//         <Col md={3}>
//           <Form.Label>Flat</Form.Label>
//           <Form.Control
//             placeholder="Auto-detected"
//             value={flatLabel}
//             onChange={(e) => setFlatLabel(e.target.value)}
//             disabled={!!flatLabel}
//           />
//         </Col>
//         <Col md={3}>
//           <Form.Label>Type</Form.Label>
//           <Form.Select
//             value={form.visitorType}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, visitorType: e.target.value }))
//             }
//           >
//             <option value="delivery">Delivery</option>
//             <option value="guest">Guest</option>
//             <option value="service">Service</option>
//             <option value="cab">Cab</option>
//             <option value="other">Other</option>
//           </Form.Select>
//         </Col>
//         <Col md={3}>
//           <Form.Label>Visitor Name</Form.Label>
//           <Form.Control
//             value={form.visitorName}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, visitorName: e.target.value }))
//             }
//           />
//         </Col>
//         <Col md={3}>
//           <Form.Label>Phone</Form.Label>
//           <Form.Control
//             value={form.phone}
//             onChange={(e) => setForm((s) => ({ ...s, phone: e.target.value }))}
//           />
//         </Col>
//         <Col md={9}>
//           <Form.Label>Purpose</Form.Label>
//           <Form.Control
//             value={form.purpose}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, purpose: e.target.value }))
//             }
//           />
//         </Col>
//         <Col md={3}>
//           <Form.Label>Validity (minutes)</Form.Label>
//           <Form.Control
//             type="number"
//             min={15}
//             max={1440}
//             value={form.validityMins}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, validityMins: Number(e.target.value) }))
//             }
//           />
//         </Col>
//         <Col xs="auto" className="mt-2">
//           <Button disabled={creating} onClick={onCreatePass}>
//             {creating ? "Generating…" : "Generate QR Pass"}
//           </Button>
//         </Col>
//       </Row>

//       {qrToken && (
//         <div className="mt-4 d-flex flex-column align-items-center">
//           <QRCode value={shareUrl} size={200} />
//           <div className="text-muted mt-2 small">
//             Share this QR / link with the visitor
//           </div>
//           <div className="mt-1">
//             <a href={shareUrl} target="_blank" rel="noreferrer">
//               {shareUrl}
//             </a>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useVisitorActions } from "../../hooks/useVisitorRequests";
import { makeToken } from "../../hooks/useQR";
import {
  serverTimestamp,
  Timestamp,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import QRCode from "react-qr-code";
import { db } from "../../firebase";

export default function ResidentPassGenerator({ community, currentUser }) {
  const { createRequest } = useVisitorActions();

  const [flatLabel, setFlatLabel] = useState("");
  const [form, setForm] = useState({
    visitorType: "delivery",
    visitorName: "",
    phone: "",
    purpose: "",
    validityMins: 120,
  });

  const [qrToken, setQrToken] = useState("");
  const [shareUrl, setShareUrl] = useState("");
  const [creating, setCreating] = useState(false);
  const [err, setErr] = useState("");

  // Auto-pick flat from units (or use a field from user profile if you have one)
  useEffect(() => {
    let stop = false;
    const loadUnit = async () => {
      if (!community?.id || !currentUser?.uid) return;
      // If your user doc has flatLabel field, prefer that:
      // setFlatLabel(currentUser.flatLabel ?? '');
      // else fall back to communities/{id}/units where occupiedByUid == currentUser.uid
      const q = query(
        collection(db, "communities", community.id, "units"),
        where("occupiedByUid", "==", currentUser.uid)
      );
      const snap = await getDocs(q);
      if (!stop && !snap.empty) {
        const doc = snap.docs[0].data();
        setFlatLabel(doc?.flatLabel || "");
      }
    };
    loadUnit();
    return () => {
      stop = true;
    };
  }, [community?.id, currentUser?.uid]);

  const onCreatePass = async () => {
    setErr("");
    if (!currentUser?.uid) {
      setErr("Please sign in as resident to create a pass.");
      return;
    }
    if (!flatLabel || !form.visitorName) {
      setErr("Flat and Visitor Name are required");
      return;
    }
    try {
      setCreating(true);
      const token = makeToken("VT");
      const expires = Timestamp.fromDate(
        new Date(Date.now() + form.validityMins * 60 * 1000)
      );

      await createRequest({
        communityId: community.id,
        flatLabel,
        residentUid: currentUser.uid,
        visitorType: form.visitorType,
        visitorName: form.visitorName.trim(),
        phone: form.phone.trim(),
        purpose: form.purpose.trim(),
        createdBy: {
          uid: currentUser.uid,
          role: "resident",
          method: "resident-pass",
        },
        qrToken: token,
        qrExpiresAt: expires,
        status: "preapproved",
        createdAt: serverTimestamp(),
      });

      const url = `${window.location.origin}/visit/${token}`;
      setQrToken(token);
      setShareUrl(url);
    } catch (e) {
      setErr(e?.message || "Failed to create pass");
    } finally {
      setCreating(false);
    }
  };

  return (
    <>
      <h5 className="mb-3">Resident Pre‑Approval Pass</h5>
      {err && <Alert variant="danger">{err}</Alert>}

      <Row className="g-2">
        <Col md={3}>
          <Form.Label>Flat</Form.Label>
          <Form.Control
            placeholder="Auto-detected"
            value={flatLabel}
            onChange={(e) => setFlatLabel(e.target.value)}
            disabled={!!flatLabel}
          />
        </Col>
        <Col md={3}>
          <Form.Label>Type</Form.Label>
          <Form.Select
            value={form.visitorType}
            onChange={(e) =>
              setForm((s) => ({ ...s, visitorType: e.target.value }))
            }
          >
            <option value="delivery">Delivery</option>
            <option value="guest">Guest</option>
            <option value="service">Service</option>
            <option value="cab">Cab</option>
            <option value="other">Other</option>
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Label>Visitor Name</Form.Label>
          <Form.Control
            value={form.visitorName}
            onChange={(e) =>
              setForm((s) => ({ ...s, visitorName: e.target.value }))
            }
          />
        </Col>
        <Col md={3}>
          <Form.Label>Phone</Form.Label>
          <Form.Control
            value={form.phone}
            onChange={(e) => setForm((s) => ({ ...s, phone: e.target.value }))}
          />
        </Col>
        <Col md={9}>
          <Form.Label>Purpose</Form.Label>
          <Form.Control
            value={form.purpose}
            onChange={(e) =>
              setForm((s) => ({ ...s, purpose: e.target.value }))
            }
          />
        </Col>
        <Col md={3}>
          <Form.Label>Validity (minutes)</Form.Label>
          <Form.Control
            type="number"
            min={15}
            max={1440}
            value={form.validityMins}
            onChange={(e) =>
              setForm((s) => ({ ...s, validityMins: Number(e.target.value) }))
            }
          />
        </Col>
        <Col xs="auto" className="mt-2">
          <Button disabled={creating} onClick={onCreatePass}>
            {creating ? "Generating…" : "Generate QR Pass"}
          </Button>
        </Col>
      </Row>

      {qrToken && (
        <div className="mt-4 d-flex flex-column align-items-center">
          <QRCode value={shareUrl} size={200} />
          <div className="text-muted mt-2 small">
            Share this QR / link with the visitor
          </div>
          <div className="mt-1">
            <a href={shareUrl} target="_blank" rel="noreferrer">
              {shareUrl}
            </a>
          </div>
        </div>
      )}
    </>
  );
}
